<!-- @format -->

<template>
	<!-- width: (isExpand ?width:30) + 19 + 'px'  -->
	<div ref="platformTree" :style="{ borderRight: onlyTree ? 'none' : '' }" class="platform-tree">
		<div v-if="angleDouble && !onlyTree" class="layout-header-tools orgTreeSty">
			<el-tooltip :hide-after="500" :content="isExpand ? '收缩' : '展开'" placement="top">
				<el-link class="pin-btn" :underline="false" @click="handleExpandCollapse">
					<i class="ibps-icon ibps-icon-pack-up-admin-icon" />
				</el-link>
			</el-tooltip>
		</div>
		<div v-if="title" ref="header" class="layout-header">
			<div v-show="isExpand" :style="{ width: width - 95 + 'px' }" class="layout-header-title ibps-ellipsis">
				<el-tooltip
					class="item"
					effect="dark"
					:enterable="false"
					:content="title"
					placement="top"
					:disabled="width - 105 >= getTextWidth(title)"
				>
					<span> {{ title }}</span>
				</el-tooltip>
			</div>
		</div>

		<div
			v-show="!isExpand && !onlyTree"
			class="platform-show"
			:style="{ height: (isExpand ? treeHeight : height) + 'px' }"
		>
			&nbsp;
		</div>
		<span v-if="toolbars && !onlyTree" class="platform-fr layout-header-more">
			<span v-show="isExpand" ref="toolbar" class="platform-tree-toolbar">
				<el-dropdown size="default">
					<el-button icon="MoreFilled" link class="layout-header-more-button" size="small" />
					<template #dropdown>
						<el-dropdown-menu class="ibps-table-dropdown-menu">
							<pc-toolbar :actions="toolbars" :identity="identity" :type="'menu'" @action-event="handleActionEvent" />
						</el-dropdown-menu>
					</template>
				</el-dropdown>
			</span>
		</span>

		<div
			v-if="$slots.searchForm"
			v-show="isExpand && !onlyTree"
			ref="searchForm"
			class="platform-tree-search-form"
			:style="{ width: width + 'px', display: 'inherit' }"
		>
			<slot name="searchForm" />
		</div>

		<div v-show="isExpand" :style="{ height: (isExpand ? treeHeight : height) + 'px' }" class="platform-tree-main">
			<el-scrollbar style="height: 100%; width: 100%" wrap-class="platform-tree-wrapper">
				<el-tree
					ref="elTree"
					:key="treeKey"
					v-loading="loading"
					class="treeSty"
					:data="!lazy ? treeData : null"
					:lazy="lazy"
					:load="load"
					:props="defaultProps"
					v-bind="treeOptions"
					:default-expand-all="true"
					:expand-on-click-node="true"
					:highlight-current="true"
					@node-click="handleNodeClick"
					@node-contextmenu="handleNodeContextmenu"
				>
					<template #default="{ node, data }">
						<span
							class="platform-custom-tree-node"
							:class="{ 'is-disabled': data.disabled }"
							style="width: 100%"
							@mouseenter="mouseenter(data)"
							@mouseleave="mouseleave(data)"
						>
							<!-- <i class="tree-icon" :class="setIconMain(node)" style="margin-right: 8px"></i> -->
							<el-tooltip
								class="item"
								effect="dark"
								:enterable="false"
								:content="node.label"
								placement="top"
								:disabled="nodeWidth(node) >= stringWidth(node)"
							>
								<span v-if="isRenderI18n">
									{{ ellipsis(node.label, nodeWidth(node)) }}
								</span>
								<span v-else>
									{{ ellipsis(node.label, nodeWidth(node)) }}
								</span>
							</el-tooltip>
							<span
								v-show="(data.$show || data.$visible) && contextmenus.length > 0"
								class="platform-fr dropdownSty"
								style="display: inline-block; width: 20px; height: 20px"
							>
								<el-button
									icon="MoreFilled"
									link
									class="layout-header-more-button"
									size="small"
									@click.prevent.stop="handleNodeMenuClick($event, data)"
								/>
							</span>
						</span>
					</template>
				</el-tree>
			</el-scrollbar>

			<!--操作菜单-->
			<pc-contextmenu
				v-if="contextmenus"
				ref="contextmenu"
				:z-index="contextmenuZIndex"
				:data="contextmenuList"
				@menu-click="handleContextmenuClick"
			/>
		</div>
	</div>
</template>
<script>
	import { merge } from '@power/utils';
	import { TreeUtils } from '@/utils/tree';
	import { $utils } from '@/utils/publicUtils';
	import PcContextmenu from '@/components/pc-contextmenu/index.vue';
	import { checkContextmenuPermission } from '@/components/pc-crud/mixin/permission';
	import PcToolbar from '@/components/pc-toolbar/index.vue';

	export default {
		components: {
			PcContextmenu,
			PcToolbar,
		},
		props: {
			title: String,
			// 是否国际化渲染：isRenderI18n
			isRenderI18n: {
				type: Boolean,
				default: true,
			},
			angleDouble: {
				type: Boolean,
				default: true,
			},
			width: {
				type: Number,
				default: 200,
			},
			height: {
				type: Number,
				default: 800,
			},
			position: {
				type: String,
				default: 'west',
			},
			loading: {
				type: Boolean,
				default: false,
			},
			data: {
				type: Array,
			},
			dataType: {
				// 数据类型，tree：树形，list:列表
				type: String,
				default: 'tree',
			},
			// zIndex: {
			//   type: Number,
			//   default: 2003
			// },
			options: {
				type: Object,
				default: () => {
					return {};
				},
			},
			toolbars: {
				type: [Array, Boolean],
				default: () => {
					return [
						{
							key: 'refresh',
							label: '刷新',
						},
						{
							key: 'expand',
							label: '展开',
						},
						{
							key: 'compress',
							label: '收缩',
						},
					];
				},
			},
			contextmenus: {
				type: Array,
				default: () => {
					return [];
				},
			},
			load: Function,
			lazy: {
				type: Boolean,
				default: false,
			},
			identity: {
				type: String,
			},
			/**
			 * 是否受权限控制
			 */
			accessControl: {
				type: Boolean,
				default: true,
			},
			onlyTree: {
				type: Boolean,
				default: false,
			},
			treeKey: {
				type: [Number, String],
			},
		},
		data() {
			return {
				treeHeight: this.height,
				isExpand: true,
				autoPlacement: true,
				contextmenuData: {},
				contextmenuList: [],
				operations: true,
				disabled: true,
				contextmenuZIndex: 2003,
				defaultProps: {
					children: 'children',
					label: 'label',
				},
			};
		},
		computed: {
			treeData() {
				if (!this.data || this.data.length === 0) return [];
				if (this.dataType === 'list') {
					const data = this.adjustmentListTypeData(JSON.parse(JSON.stringify(this.data)));
					return data;
				} else {
					return TreeUtils.transformToTreeFormat(JSON.parse(JSON.stringify(this.data)), {
						idKey: this.treeOptions['node-key'],
						pIdKey: this.pidKey,
						childrenKey: this.treeOptions['props']['children'],
					});
				}
			},
			treeOptions() {
				const defaultOptions = {
					rootPId: null,
					'node-key': 'id',
					'pid-key': 'parentId',
					'default-expand-all': true,
					'expand-on-click-node': false,
					'highlight-current': true,
					props: {
						children: 'children',
						label: 'name',
					},
				};
				return merge(defaultOptions, this.options);
			},
			pidKey() {
				return this.treeOptions['pid-key'];
			},
			rootPId() {
				return this.treeOptions['rootPId'] || null;
			},
			showIcon() {
				return this.treeOptions['showIcon'] || false;
			},
			expandCollapseIcon() {
				if (this.position === 'west') {
					return this.isExpand ? 'ExpandCollapseIcon' : 'UnExpandCollapseIcon';
				} else {
					return this.isExpand ? 'UnExpandCollapseIcon' : 'ExpandCollapseIcon';
				}
			},
			setIconMain() {
				return (node) => {
					// debugger
					if (node.expanded) {
						if (node.isLeaf) {
							return '';
						} else {
							return 'element-icons el-icon-jianhao';
						}
					} else {
						return 'element-icons el-icon-jiahao';
					}
				};
			},
			nodeWidth() {
				return (node) => {
					// 树的宽度-前面图标的宽度-操作图标
					return this.width - 24 * node.level - 35 - (this.showIcon ? 12 : 0);
				};
			},
			stringWidth() {
				return (node) => {
					return this.getTextWidth(node.label);
				};
			},
			ellipsis() {
				return (text, nodeWidth) => {
					if (!text) return '';
					const textWidth = this.getTextWidth(text);
					if (textWidth > nodeWidth) {
						// 对英文和数字的长度处理
						const len = (nodeWidth / textWidth) * ($utils.textLength(text) / 2);
						return `${text.slice(0, Math.floor(len))}..`;
					}
					return text;
				};
			},
		},
		watch: {
			height() {
				this.handleTreeHeight();
			},
			zIndex(val) {
				this.contextmenuZIndex = val;
			},
			active: {
				handler(val) {
					if (val) {
						let treeHeight;
						setTimeout(() => {
							treeHeight = document.documentElement.clientHeight;
							this.handleTreeHeight(val, treeHeight);
						}, 50);
					} else {
						this.handleTreeHeight();
					}
				},
				immediate: true,
			},
		},
		mounted() {
			this.handleTreeHeight();
		},
		beforeUnmount() {
			this.contextmenuData = null;
			this.contextmenuList = null;
		},
		methods: {
			adjustmentListTypeData(data) {
				if (!this.options.categoryId || !data) return data || [];
				const categoryId = this.options.categoryId;
				const rootData = data.find((d) => d.id === categoryId);
				const childern = data.filter((d) => d.id !== categoryId);
				if (!rootData) return;
				rootData[this.treeOptions['props']['children']] = childern;
				return [rootData];
			},
			getIcon(data) {
				let icon = data ? data[this.treeOptions['iconKey'] || 'icon'] : 'list-alt';
				if (icon) {
					return icon;
				}
				if (data[this.pidKey] === this.rootPId) {
					icon = this.treeOptions['rootIcon'] || 'home';
				} else {
					icon = this.treeOptions['nodeIcon'] || 'list-alt';
				}
				return icon;
			},
			handleTreeHeight(active = false, h) {
				!active ? (this.treeHeight = this.height) : (this.treeHeight = JSON.parse(JSON.stringify(h)));
				if (this.$refs.header) {
					this.treeHeight -= this.$refs.header.clientHeight + 20;
				}
				if (this.$refs.toolbar) {
					this.treeHeight -= this.$refs.toolbar.clientHeight;
				}
				if (this.$refs.searchForm) {
					this.treeHeight -= this.$refs.searchForm.clientHeight;
				}
				if (active) {
					this.treeHeight -= this.treeHeight / 6.909;
				}
			},
			handleActionEvent(action, position, data) {
				const command = action.key;
				if (command === 'expand') {
					this.expandCompressTree(true);
				} else if (command === 'compress') {
					this.expandCompressTree(false);
				}
				this.$emit('action-event', command, position, data);
			},
			expandCompressTree(expanded) {
				for (let i = 0; i < this.$refs.elTree.store._getAllNodes().length; i++) {
					this.$refs.elTree.store._getAllNodes()[i].expanded = expanded;
				}
			},
			handleNodeClick(data, node, obj) {
				if (node.data.disabled) return;
				this.$refs.contextmenu && this.$refs.contextmenu.hide();
				this.$emit('node-click', data, node, obj);
			},
			getNode(data) {
				return this.$refs.elTree.getNode(data);
			},
			refreshNode(id) {
				const node = this.$refs.elTree.getNode(id); // 通过节点id找到对应树节点对象
				node.loaded = false;
				node.expand(); // 主动调用展开节点方法，重新查询该节点下的所有子节点
			},
			/**
			 * 处理更多菜单
			 */
			handleNodeMenuClick(event, data) {
				this.handleNodeMenu(event, data);
			},
			/**
			 * 处理节点右键菜单
			 */
			handleNodeContextmenu(event, data) {
				this.handleNodeMenu(event, data);
			},
			handleNodeMenu(event, data) {
				if (!this.contextmenus || this.contextmenus.length === 0) return;
				this.handleContextmenuList(data); // 组装菜单数据
				this.contextmenuData = data;
				this.$refs.contextmenu.handleContextMenu(event, true, data);
			},
			handleContextmenuList(data) {
				const isRoot = data[this.pidKey] === this.rootPId;
				const contextmenuList = [];
				for (let i = 0; i < this.contextmenus.length; i++) {
					const menu = this.contextmenus[i];
					delete menu.icon;
					if (!menu.rights) {
						contextmenuList.push(menu);
					} else {
						if (Array.isArray(menu.rights)) {
							if (menu.rights.indexOf('node') > -1 && !isRoot) {
								contextmenuList.push(menu);
							}
						} else if (typeof menu.rights === 'function') {
							if (menu.rights.call(this, menu, data, isRoot)) {
								contextmenuList.push(menu);
							}
						}
					}
				}
				this.contextmenuList = contextmenuList;
				// 校验是否有菜单权限
				this.contextmenuList = checkContextmenuPermission(contextmenuList, this.identity);
			},
			handleContextmenuClick(item) {
				this.$emit(
					'action-event',
					item.key,
					'tree-operationmenu',
					this.contextmenuData[this.pkKey],
					this.contextmenuData,
				);
			},
			handleExpandCollapse() {
				this.isExpand = !this.isExpand;
				this.$emit('expand-collapse', this.isExpand);
			},
			remove(data) {
				this.$refs.elTree.remove(data);
			},
			getCurrentKey() {
				return this.$refs.elTree.getCurrentKey();
			},
			mouseenter(data) {
				data.$show = true;
			},
			mouseleave(data) {
				data.$show = false;
			},
			// 获取字符串长度
			getTextWidth(str) {
				const dom = document.createElement('span');
				dom.style.display = 'inline-block';
				dom.textContent = str;
				document.body.appendChild(dom);
				const width = dom.offsetWidth;
				document.body.removeChild(dom);
				return width;
			},
			visibleChange(visible, data) {
				data.$visible = visible;
			},
			handleNodeShow(data) {
				const isRoot = data[this.pidKey] === this.rootPId;
				let contextmenuList = [];
				for (let i = 0; i < this.contextmenus.length; i++) {
					const menu = this.contextmenus[i];
					delete menu.icon;
					if (!menu.rights) {
						contextmenuList.push(menu);
					} else {
						if (Array.isArray(menu.rights)) {
							if (menu.rights.indexOf('node') > -1 && !isRoot) {
								contextmenuList.push(menu);
							}
						} else if (typeof menu.rights === 'function') {
							if (menu.rights.call(this, menu, data, isRoot)) {
								contextmenuList.push(menu);
							}
						}
					}
				}
				// 校验是否有菜单权限
				contextmenuList = checkContextmenuPermission(contextmenuList, this.identity, {
					accessControl: this.accessControl,
				});
				if (contextmenuList.length > 0) return true;
				return false;
			},
		},
	};
</script>
<style lang="scss">
	$border-color: #e7eaef;

	.platform-tree {
		height: 100% !important;
		background-color: #fff;
		// border-right: 1px solid $border-color;
		padding-bottom: 20px;

		.layout-header {
			border-radius: 3px;
			margin: 20px 0px 0px 20px;
			display: inline-block;
			height: 28px;
			font-weight: bold;
			text-align: center;
			position: relative;
			overflow: hidden;
			// background:#F5F7F9;
			&--medium {
				height: 40px;
			}

			&--small {
				height: 35px;
			}

			&--mini {
				height: 30px;
			}

			.layout-header-title {
				float: left;
				text-align: left;
				font-size: 18px;
			}
		}

		.layout-header-more {
			padding: 10px 2px 0px 0px;
			background-color: #ffffff;

			.layout-header-more-button {
				border-radius: 5px;
				padding: 9px 10px !important;
				background: #fff !important;
				color: #1d2129 !important;
			}
		}

		.orgTreeSty {
			bottom: 4px;
			right: 10px;
			z-index: 99;
			position: absolute;
			padding: 0;

			.pin-btn {
				cursor: pointer;
				line-height: 28px;
				color: #c4c4c4;
				font-size: 16px;
				margin-left: 5px;

				svg {
					path:nth-of-type(1) {
						fill: #ffffff;
					}
				}
			}
		}

		.platform-show {
			background: #ffffff;
		}

		.dropdownSty {
			transform: rotate(90deg);

			.dropdown-btn {
				display: inline-block;
				// z-index: 999999;
			}
		}

		.treeSty {
			padding-top: 18px;
			background: #fff !important;
		}

		.platform-tree-toolbar {
			height: 35px;
			padding: 5px;
		}

		.platform-tree-search-form {
			padding: 5px 5px 10px 15px;
			background: #ffffff;
			display: inline-block;
		}

		.platform-tree-main {
			background: #ffffff;
			padding: 0px 0px 0px 17px;
		}

		.platform-tree-wrapper {
			padding-right: 15px;
			background: #ffffff;

			.el-tree-node__content {
				height: 30px;
				// padding-bottom: 6px;
			}

			.is-current > .el-tree-node__content:first-of-type {
				color: #409eff;
			}
		}

		.platform-custom-tree-node {
			font-size: 12px;
			// padding-right: 8px;
			.el-icon-more:hover {
				background-color: #e0e8ed;
				border-radius: 3px;
			}

			.imageMiddleSty {
				vertical-align: middle !important;
			}

			.tree-icon {
				font-size: 14px;
			}
		}

		.platform-custom-tree-node.is-disabled {
			color: rgba(0, 0, 0, 0.45);
			cursor: not-allowed;
		}
	}
</style>
